import { render } from "./TagItemWithEllipsis.vue?vue&type=template&id=f3a51332"
const script = {}

import "./TagItemWithEllipsis.vue?vue&type=style&index=0&id=f3a51332&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__